module.exports = __webpack_public_path__ + "fonts/iconfont.be8f523.ttf";